import { Actions, UseGameState } from './types';

export const defaultState = (): UseGameState<any> => ({
  activityData: {},
  activityState: {
    count: 1,
    currentPageCompleted: false,
    gameEnd: false,
    step: 1,
    showAnimation: false,
  },
  closeActivity: {
    title: 'closeActivityTitle',
    subtitle: 'closeActivitySubtitle',
    content: 'closeActivityContent',
    continueButtonLabel: 'closeActivityButton',
    closeButtonLabel: 'continueActivityButton',
  },
  unfinishedActivity: {
    title: 'unfinishedActivityTitle',
    subtitle: 'unfinishedActivitySubtitle',
    content: 'unfinishedActivityContent',
    continueButtonLabel: 'unfinishedContinueButton',
    closeButtonLabel: 'unfinishedStayButton',
  },
  currentData: [],
  isRestarting: false,
  loading: true,
  SVGsLoading: true,
  error: null,
  isActivityOver: false,
});

export const reducers = (state: UseGameState<any>, action: Actions): UseGameState<any> => {
  switch (action.type) {
    case 'HANDLE_LOADING':
      return { ...state, loading: action.payload.loading, error: null };
    case 'HANDLE_SVG_LOADING':
      return { ...state, SVGsLoading: action.payload.loading, error: null };
    case 'HANDLE_ERROR':
      return { ...state, error: action.payload.error, loading: false };
    case 'SET_IS_ACTIVITY_OVER':
      return { ...state, ...{ isActivityOver: action.payload } };
    case 'HANDLE_CURRENT_PAGE_COMPLETION':
      return {
        ...state,
        activityState: {
          ...state.activityState,
          currentPageCompleted: action.payload.completed,
        },
      };
    case 'ON_GAME_END':
      return {
        ...state,
        activityState: {
          ...state.activityState,
          gameEnd: action.payload.gameEnd,
        },
      };
    case 'RESET_ACTIVITY':
      return { ...state, isRestarting: action.payload.isRestarting };
    case 'SET_DATA':
      return { ...state, activityData: { ...action.payload } };
    case 'SET_CURRENT_DATA':
      return { ...state, currentData: action.payload.currentData };
    case 'SET_SHOW_ANIMATION':
      return {
        ...state,
        activityState: {
          ...state.activityState,
          showAnimation: action.payload.showAnimation,
        },
      };
  }
};
